(() => {
  'use strict';

  const config = window.ThemeLicenseConfig;
  const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  if (!config || !config.enabled || inDesignMode) return;

  const lockTheme = () => {
    if (document.getElementById('theme-license-lock')) return;

    const overlay = document.createElement('div');
    overlay.id = 'theme-license-lock';
    overlay.setAttribute('role', 'alertdialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = '<div><p>Bu tema için lisans doğrulaması yapılamadı.</p><small>Lütfen tema sağlayıcınızla iletişime geçin.</small></div>';
    Object.assign(overlay.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '2147483647',
      display: 'grid',
      placeItems: 'center',
      padding: '24px',
      background: '#f7f7f7',
      color: '#161616',
      fontFamily: 'system-ui, sans-serif',
      textAlign: 'center'
    });
    Object.assign(overlay.firstElementChild.style, {
      maxWidth: '420px',
      padding: '32px',
      border: '1px solid #d8d8d8',
      borderRadius: '12px',
      background: '#fff'
    });
    document.body.appendChild(overlay);
  };

  const expiresAt = new Date(`${config.expiresAt}T23:59:59Z`);
  if (Number.isNaN(expiresAt.getTime()) || Date.now() > expiresAt.getTime() || !config.key || !config.shop) {
    lockTheme();
    return;
  }

  const endpoint = 'https://script.google.com/macros/s/AKfycbxXZyUvNoXfJJZcysM3Cf5K8K-eDZWUhb809V-6_oB_VfFVSRjhVIVirJGXN0gn9G1rEg/exec';
  const url = `${endpoint}?key=${encodeURIComponent(config.key)}&shop=${encodeURIComponent(config.shop)}`;
  const maxAttempts = 3;
  const retryDelay = 1500;

  const wait = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  const validateLicense = async () => {
    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
      try {
        const response = await fetch(url, {
          method: 'GET',
          mode: 'cors',
          cache: 'no-store',
          credentials: 'omit'
        });

        if (!response.ok) throw new Error(`License request failed: ${response.status}`);

        const result = await response.json();

        if (result && result.valid === true && result.reason === 'active') return;
        lockTheme();
        return;
      } catch (error) {
        if (attempt === maxAttempts) {
          lockTheme();
          return;
        }

        await wait(retryDelay);
      }
    }
  };

  validateLicense();
})();
